import Vue from "vue";
import VueRouter from "vue-router";
// routers routers由一个配置文件分拆为多个配置子文件
import routes from "./routes";
// import routes from "./routes/routes-gongjiao.js";
// import routes from "./routes/routes-ditie.js";
// import routes from "./routes/routes-chuzuche.js";
// import routes from "./routes/routes-gaotie.js";
// import routes from "./routes/routes-jichang.js";
// import routes from "./routes/routes-lunchuan.js";


Vue.use(VueRouter); // 使用一个vue插件

const router = new VueRouter({
  // 配置
  routes, // 路由匹配规则
  // mode: "history", 改成下面的模式
  mode: "hash",
});


export default router;
